var map = {
	"./biological_hazard.svg": "f4d2",
	"./cgl_insurance_included.svg": "2ea0",
	"./cgl_insurance_required.svg": "962a",
	"./chemical_hazerd.svg": "c1e1",
	"./e&o_insurance_required.svg": "b00e",
	"./explosive_materials.svg": "36f4",
	"./flammable_materials.svg": "e572",
	"./heated.svg": "4307",
	"./high_pressure_warning.svg": "f992",
	"./indoor.svg": "e16b",
	"./low_temperature_warning.svg": "93b1",
	"./no_heated.svg": "72be",
	"./outdoor.svg": "0bf9",
	"./radioactive_hazard.svg": "5349",
	"./use_ear_protection.svg": "9ef3",
	"./work_in_mask.svg": "de0a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "985b";